export default __webpack_public_path__ + "static/media/03650000-6bec-ac1f-0fad-08dac1891ec5.0262d7e4.webp";